// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__2lGYY","disabled":"Card_disabled__esZCh","block":"Card_block__stYHG","itemContent":"Card_itemContent__aA2g3","title":"Card_title__o3fsK","row":"Card_row__prSCC"};